import { useMount } from '@tiger/hooks';
import { FC, FormEvent } from 'react';
import { useForm, withForm } from 'react-bootstrap-formutil';
import { useLocation } from 'react-router-dom';
import BackNextButtons from 'components/BackNextButtons';
import ScrollTop from 'components/base/ScrollTop';
import Debug from 'components/Debug';
import {
    TrustedContactContent,
    TrustedContactPersonDataItem,
    useAddContact,
    useEditContact
} from 'components/forms/TrustedContactPerson';
import { usePowerNavigate } from 'components/PowerNavigate';
import Toast from 'components/Toast';
import values from 'stores/values';

// 开户收集受信联系人二级页面 https://tigertech.feishu.cn/wiki/HBoDws68riyoaqkLQKrcYmgpnUk
const TrustedContact: FC<{
    isSSN: boolean;
}> = ({ isSSN }) => {
    const navigate = usePowerNavigate();
    const { type = 'add', data } = (useLocation().state || {}) as {
        type: 'add' | 'edit';
        data?: TrustedContactPersonDataItem;
    };
    const { $params, $invalid, $errors, $getFirstError, $batchState, $setValues } =
        useForm<TrustedContactPersonDataItem>();
    const { trigger: triggerAddContact } = useAddContact();
    const { trigger: triggerEditContact } = useEditContact();
    const isEdit = type === 'edit';

    const handleSubmit = async (ev: FormEvent) => {
        ev.preventDefault();

        if ($invalid) {
            $batchState({
                $dirty: true,
                $touched: true
            });

            Toast.show($getFirstError());
        } else {
            Toast.loading(true);

            try {
                if (isEdit) {
                    await triggerEditContact($params);

                    Toast.show(__('Edit successfully'));
                } else {
                    await triggerAddContact($params);

                    Toast.show(__('Add successfully'));
                }

                // 使用-1返回上一步即可，使用指定路由（../job）的方式会增加一次路由栈，回到job页面后再点击go back返回上一步不符合预期，因为BackNextButtons中使用的是navigate(-1)
                navigate(-1);
            } catch (error) {
                Toast.show(error);
            }

            Toast.loading(false);
        }
    };

    useMount(() => {
        const oldShowProgressBar = values.showProgressBar;

        values.setShowProgressBar(false);

        // 只在编辑时设置一次默认值
        if (isEdit && data) {
            $setValues(data);
        }

        return () => {
            values.setShowProgressBar(oldShowProgressBar);
        };
    });

    return (
        <>
            <ScrollTop />
            <h3 className="open-title mt-0">
                {isEdit ? __('EDIT TRUSTED CONTACT PERSON') : __('ADD TRUSTED CONTACT PERSON')}
            </h3>
            <form noValidate onSubmit={handleSubmit}>
                <TrustedContactContent isSSN={isSSN} data={data} />
                <BackNextButtons
                    sticky
                    hidePrev
                    nextBtnProps={{
                        content: __('Save Changes')
                    }}
                />
            </form>
            <Debug title="$params" data={$params} />
            <Debug title="$errors" data={$errors} />
        </>
    );
};

export default withForm(TrustedContact);
